import { IconName, useModal, type UseModalResult } from '@axinom/mosaic-ui';
import React from 'react';
import { RowExplorer } from './RowExplorer';
import type { RowSelectionExplorerProps } from './RowExplorer.types';

interface UseRowSelectExplorerModalOptions {
  title?: string;
  excludeItems?: string[];
  onSelection: RowSelectionExplorerProps['onSelection'];
  type: string;
}

export const useRowSelectExplorerModal = ({
  excludeItems,
  type,
  title = `Select ${
    type === 'ContainerImage'
      ? 'Container Image'
      : type === 'ServicePiletArtifacts'
      ? 'Pilet Artifact(s)'
      : 'Deployment Manifest'
  }`,
  onSelection,
}: UseRowSelectExplorerModalOptions): UseModalResult =>
  useModal(({ closeModal }) => (
    <RowExplorer
      kind="SelectionExplorer"
      title={title}
      stationKey={'EpisodeSelection'}
      onSelection={(selection) => {
        onSelection?.(selection);
        closeModal();
      }}
      excludeItems={excludeItems}
      type={type}
      actions={[
        {
          label: 'Cancel',
          icon: IconName.X,
          onClick: closeModal,
        },
      ]}
      enableSelectAll={false}
    />
  ));
